import React from 'react';
import Table from './../../../components/table';
import { sectionHead } from './_common';
import { FormattedMessage } from 'react-intl';
import { getAddress } from '../../../utilities/string';
import messages from '../../../text/messages';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { w4TableRows } from '../../../utilities/regime';

class GeneralTab extends React.Component {
    render() {
        const { job, user, roleType } = this.props;
        const { contractor_address } = job;

        let tableData = {
            columns: [
                { valueMap: d => <span className="row-label">{d.label}</span>, size: 'col-xs-12 col-md-3' },
                { valueMap: d => <span className="row-value">{d.value}</span>, size: 'col-xs-12 col-md-9' }
            ],
            data: [
                sectionHead(messages.personalInformation, true),
                { label: <FormattedMessage {...messages.email} />, value: user.email },
                { label: <FormattedMessage {...messages.gender} />, value: user.gender || '-' },
                {
                    label: <FormattedMessage {...messages.phone} />,
                    value: user.phone ? formatPhoneNumberIntl(user.phone) : <FormattedMessage {...messages.notProvided} />
                },
                { label: <FormattedMessage {...messages.address} />, value: getAddress(contractor_address) },
                { label: <FormattedMessage {...messages.linkedIn} />, value: user.linkedin_url || '-' },
                { label: <FormattedMessage {...messages.dateOfBirth} />, value: user.birthday_date },

                ...(roleType === 'admin'
                    ? w4TableRows(
                          job && job.regime ? job.regime : { onboarding_flow_id: user && user.w4_fields && user.w4_fields.employee_statement ? 'UK' : 'US' },
                          user
                      )
                    : []),
                sectionHead(messages.emergencyContact),
                { label: <FormattedMessage {...messages.name} />, value: user.emergency_name || <FormattedMessage {...messages.notProvided} /> },
                { label: <FormattedMessage {...messages.email} />, value: user.emergency_email || <FormattedMessage {...messages.notProvided} /> },
                {
                    label: <FormattedMessage {...messages.phone} />,
                    value: user.emergency_phone ? formatPhoneNumberIntl(user.emergency_phone) : <FormattedMessage {...messages.notProvided} />
                },
                {
                    label: <FormattedMessage {...messages.relationship} />,
                    value: user.emergency_relationship || <FormattedMessage {...messages.notProvided} />
                }
            ]
        };

        return <Table {...tableData} rowStyle={'onboarding-table-row'} />;
    }
}

GeneralTab.defaultProps = {
    job: {}
};

export default GeneralTab;



// WEBPACK FOOTER //
// ./src/pages/worker/tabs/general.jsx